import { api } from './client'

export interface ExpenseCategory {
    id: string
    code: string
    name: string
    description?: string
    is_active: boolean
    // system_key is non-null only for a category the system relies on
    // (currently just the "Chưa phân loại" fallback) — locks
    // rename/deactivate/delete both server- and client-side.
    system_key?: string
    created_at: string
    updated_at: string
    deleted_at?: string
}

export interface UpsertExpenseCategoryRequest {
    code: string
    name: string
    description?: string
    is_active: boolean
}

export interface ListExpenseCategoriesParams {
    search?: string
    is_active?: boolean
    page?: number
    per_page?: number
}

export const expenseCategoryApi = {
    list: (params?: ListExpenseCategoriesParams) =>
        api.get<ExpenseCategory[]>('/expense-categories', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    getById: (id: string) =>
        api.get<ExpenseCategory>(`/expense-categories/${id}`),
    create: (data: UpsertExpenseCategoryRequest) =>
        api.post<ExpenseCategory>('/expense-categories', data),
    update: (id: string, data: UpsertExpenseCategoryRequest) =>
        api.put<ExpenseCategory>(`/expense-categories/${id}`, data),
    delete: (id: string) => api.delete(`/expense-categories/${id}`),
}
